import { useEffect, useState } from 'react';

const useFacebookSDK = (appId) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (window.FB) {
      setIsInitialized(true);
      return;
    }

    const loadFacebookSDK = () => {
      if (document.getElementById('facebook-jssdk')) return;
      const script = document.createElement('script');
      script.id = 'facebook-jssdk';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    const initializeFacebookSDK = () => {
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: appId,
          cookie: true,
          xfbml: true,
          version: 'v21.0',
        });
        console.log('FB Initiated');
        if (isMounted) {
          setIsInitialized(true);
        }
      };
    };

    loadFacebookSDK();
    initializeFacebookSDK();

    return () => {
      isMounted = false;
    };
  }, [appId]);

  return isInitialized;
};

export default useFacebookSDK;
